import { createContext, use, useEffect, useState } from "react";

export type AvatarKind = "agent" | "member";

export type AvatarResolver = (kind: AvatarKind, id: string) => Promise<string | null>;

export const AvatarResolverContext = createContext<AvatarResolver>(async () => null);

export function useAvatarUrl(kind: AvatarKind, id: string | undefined) {
    const resolve = use(AvatarResolverContext);
    const [url, setUrl] = useState<string>();

    useEffect(() => {
        if (!id) {
            setUrl(undefined);
            return undefined;
        }

        let cancelled = false;
        resolve(kind, id).then((resolved) => {
            if (!cancelled) setUrl(resolved ?? undefined);
        });

        return () => {
            cancelled = true;
        };
    }, [resolve, kind, id]);

    return url;
}
